import React from 'react';

function EmployesPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Employés</h1>
      <p>Page `fhc-employes.html` convertie en composant React.</p>
    </div>
  );
}

export default EmployesPage;
